//
import React from 'react'
import { BomPageContainer } from '../components/BomPageContainer'
import usePgControls from '../hooks/usePgControls.js'

function Size_Unit() {
    // const idRef = React.useRef('' + (Date.now() % 1000) + `-Size_Unit`)
    // console.log(`${idRef.current} in context`)
    const [pgControlsArray, handlePgNav] = usePgControls()

    const validFence = pgControlsArray[1].props.controlSessionObj.validFence

    return (
        <BomPageContainer
            titleText={'Fence Sizing'}
            pgControlsArray={pgControlsArray}
            handlePgNav={handlePgNav}
            validFence={validFence}
        />
    )
}
function NumStrand_Clr() {
    // const idRef = React.useRef('' + (Date.now() % 1000) + `-NumStrand_Clr`)
    // console.log(`${idRef.current} in context`)
    const [pgControlsArray, handlePgNav] = usePgControls()
    return (
        <BomPageContainer
            titleText={'Braid'}
            pgControlsArray={pgControlsArray}
            handlePgNav={handlePgNav}
        />
    )
}

function LinePost() {
    const [pgControlsArray, handlePgNav] = usePgControls()
    return (
        <BomPageContainer
            titleText={'Line Posts'}
            pgControlsArray={pgControlsArray}
            handlePgNav={handlePgNav}
        />
    )
}
function CornerPost() {
    const [pgControlsArray, handlePgNav] = usePgControls()
    return (
        <BomPageContainer
            titleText={'Corner Posts'}
            pgControlsArray={pgControlsArray}
            handlePgNav={handlePgNav}
        />
    )
}
function Gate() {
    const [pgControlsArray, handlePgNav] = usePgControls()
    return (
        <BomPageContainer
            titleText={'Gates'}
            pgControlsArray={pgControlsArray}
            handlePgNav={handlePgNav}
        />
    )
}
function EndPost() {
    const [pgControlsArray, handlePgNav] = usePgControls()
    return (
        <BomPageContainer
            titleText={'End Posts'}
            pgControlsArray={pgControlsArray}
            handlePgNav={handlePgNav}
        />
    )
}
function Kit_Insul() {
    const [pgControlsArray, handlePgNav] = usePgControls()
    return (
        <BomPageContainer
            titleText={'Gate Kits'}
            pgControlsArray={pgControlsArray}
            handlePgNav={handlePgNav}
        />
    )
}
export {
    Size_Unit,
    NumStrand_Clr,
    LinePost,
    CornerPost,
    Gate,
    EndPost,
    Kit_Insul,
}
